import React, { createContext, useContext, useEffect, useState } from "react";
import AISupportChat from "../components/AISupportChat/AISupportChat.component";
import { useAuthStore } from "../stores/authStore";

interface AISupportChatContextType {
  isOpen: boolean;
  sessionId: string;
  openChat: () => void;
  closeChat: () => void;
}

const AISupportChatContext = createContext<AISupportChatContextType | undefined>(
  undefined
);

export const useAISupportChat = (): AISupportChatContextType => {
  const context = useContext(AISupportChatContext);
  if (!context) {
    throw new Error(
      "useAISupportChat must be used inside AISupportChatProvider"
    );
  }
  return context;
};

export const AISupportChatProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [sessionId, setSessionId] = useState("");
  const sessionToken = useAuthStore(state => state.sessionToken);

  // Il session_id della conversazione è sempre un UUID generato lato client.
  // Ne viene generato uno nuovo all'avvio e ad ogni cambio di sessione
  // applicativa (login/refresh/logout): nuova sessione = nuova conversazione.
  useEffect(() => {
    setSessionId(crypto.randomUUID());
  }, [sessionToken]);

  const openChat = () => {
    setIsOpen(true);
    if (!sessionId) setSessionId(crypto.randomUUID());
  };

  const closeChat = () => {
    setIsOpen(false);
  };

  return (
    <AISupportChatContext.Provider
      value={ { isOpen, sessionId, openChat, closeChat } }
    >
      { children }
      <AISupportChat />
    </AISupportChatContext.Provider>
  );
};
